function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./ButtonIcon.style";
import { isCarinaGlyph, remapIconSize } from "../../Icon/types";
export var ButtonIcon = function(param) {
    var icon = param.icon, iconStyle = param.iconStyle, hasChildren = param.hasChildren, isRtl = param.isRtl, reverseSpacing = param.reverseSpacing;
    var IconGlyph = icon;
    var iconContainerStyles = useStyle({
        hasChildren: hasChildren,
        isRtl: isRtl,
        reverseSpacing: reverseSpacing
    }).iconContainerStyles;
    return _jsx("span", {
        css: iconContainerStyles,
        children: isCarinaGlyph(IconGlyph) ? _jsx(IconGlyph, _objectSpread({}, iconStyle, {
            size: remapIconSize(iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.size),
            fill: iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.color
        })) : _jsx(IconGlyph, _objectSpread({}, iconStyle))
    });
};
export default ButtonIcon;
